import { List, Grid, Box, ListItem, ListItemButton, Button } from '@mui/material'
import { PermissionList } from '../PermissionList'
import { SpinnerLoading } from '../../../../common'

export const FormPermissionAssignment = ({ useFetchInit, dataModal }) => {

    const {
        globalStates,
        Forms,
        Actions
    } = useFetchInit

    const { loadingSubmitForm } = globalStates
    
    const { FormPermissionAssignment } = Forms
    const { formState } = FormPermissionAssignment
    
    const {
        onSubmitPermissionAssignmentForm,
        handleChangePermissionAssignment
    } = Actions

    const { dataRequest } = dataModal
    
    return (
        <div className='container'>
            <div className="pt-4"></div>
            <div className="text-dark"> * Información del permiso </div>
            <div className="border-bottom border-dark"></div>
            <div className="pt-4"></div>
            <form onSubmit={(e) => onSubmitPermissionAssignmentForm(e, dataRequest.data.idusuario )}>
                <div className="pt-5"></div>
                {(formState.permissionsAssigned.length === 0) && (
                    <p>NO SE ENCONTRARON PERMISOS</p>
                )}
                {(formState.permissionsAssigned.length > 0) && (
                    <>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            {formState.permissionsAssigned.map((permiso) => (
                                <Grid item xs={12} sm={6} md={6} lg={6} key={permiso.idpermiso}>
                                    <List>
                                        <ListItem 
                                            disablePadding
                                            // secondaryAction={
                                            //     <IconButton edge="end" aria-label="delete" onClick={() => handleClickDeleteData(permiso.idpermiso)}>
                                            //         <Trash2 />
                                            //     </IconButton>
                                            // }
                                        >
                                            <ListItemButton>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        checked={permiso.is_assigned}
                                                        onChange={() => handleChangePermissionAssignment('permissionsAssigned', permiso.idpermiso)}
                                                    />
                                                    &nbsp;<strong>{permiso.nombrepermisos}</strong>
                                                </label>
                                            </ListItemButton>
                                        </ListItem>
                                        <div className="border-bottom border-secondary"></div>
                                        {permiso.hijos && permiso.hijos.length > 0 && (
                                            <PermissionList permissions={permiso.hijos}  handleChangePermissionAssignment={handleChangePermissionAssignment}/>
                                        )}
                                    </List>
                                </Grid>
                            ))}
                        </Grid>
                        
                    </>
                )}

                <div className="pt-4"></div>
                
                <Box pt={4}>
                    <Grid container spacing={2} justifyContent="flex-end">
                        <Grid item>
                            <Button
                                style={{background: "#47c4c7"}}
                                variant="contained"
                                type="submit"
                                disabled={loadingSubmitForm}
                            >
                                {(loadingSubmitForm)&&(<SpinnerLoading/>)}
                                Guardar
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </form>
            <div className="pt-4"></div>
        </div>
    )
}
